export const GENERATE_REPORT = 'GENERATE_REPORT';
export const CLEAR_REPORT = 'CLEAR_REPORT';
export const GET_REPORT_BY_DATE = 'GET_REPORT_BY_DATE';
export const GET_REPORT_BY_DATE_YEST = 'GET_REPORT_BY_DATE_YEST';
export const GET_REFUNDS = 'GET_REFUNDS';
export const GET_PAYMENTS = 'GET_PAYMENTS';
